var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex__between mb-5"},[_c('h4',{staticClass:"font-weight-bold text--primary mb-0 mr-4"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"merchant_logo"},[(_vm.logo)?_c('img',{attrs:{"src":_vm.logo,"alt":""}}):[(_vm.showForm)?_c('AddLogoButton',{attrs:{"inv":true,"logo":_vm.logo,"setLogo":_vm.setLogo}}):_vm._e()]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }